import { getContext } from '@fiverr-private/fiverr_context';
import { APP_NAME } from '../../../../../../configuration/constants';
import { SourceInfo } from './types';

export const buildSourceInfo = ({ user = {} }): SourceInfo => {
    const pageName = APP_NAME;
    const componentName = 'tailored_homepage_sub_header';
    const { userGuid, pageCtxId } = getContext();

    return {
        name: pageName,
        component: {
            name: componentName,
        },
        user,
        page: {
            ctxId: pageCtxId,
        },
        userGuid,
    };
};
